"use strict";

exports.__esModule = true;
exports.ColorPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactColor = require("react-color");
var _core = require("@blueprintjs/core");
var _modernDocumentColor = require("../../Theme/UiDesign/modernDocumentColor");
var _excluded = ["value", "onChange", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// The swatches; the last column holds the plant-state colours, which the
// modern UI shows in its own deeper tones.
var SWATCHES = [["#999999", "#666666", "#333333", "#000000"], ["#ffffff", "#e6e9f0", "#cfd2d9", "#c1c1c1"], ["#f44e3b", "#d33115", "#9f0500", "#f6928f"], ["#cca78d", "#a96b3f", "#8d3a00", "#d95e00"], ["#fcdc00", "#fcc400", "#fb9e00", "#fbbc6d"], ["#ffffcc", "#cccc99", "#ffff99", "#ffff20"], ["#dbdf00", "#b0bc00", "#808900", "#b1daae"], ["#a4dd00", "#68bc00", "#194d33", "#6fc376"], ["#68ccca", "#00a796", "#0c797d", "#005063"], ["#73d8ff", "#009ce0", "#005090", "#1678c2"], ["#aea1ff", "#7b64ff", "#442263", "#5da5da"], ["#fda1ff", "#fa28ff", "#ab149e", "#cda5cd"]];
var swatchesFor = function swatchesFor(theme) {
  return theme && theme.uiModern ? SWATCHES.map(function (column) {
    return column.map(function (color) {
      return (0, _modernDocumentColor.modernizeDocumentColor)(theme, color);
    });
  }) : SWATCHES;
};
var ColorIndicator = _styledComponents["default"].div.withConfig({
  displayName: "ColorPicker__ColorIndicator",
  componentId: "sc-s7i3fu-0"
})(["border:1px solid rgba(0,0,0,0.2);width:16px;height:16px;"]);
var ColorButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "ColorPicker__ColorButton",
  componentId: "sc-s7i3fu-1"
})(["&.", ":not([class*=\"bp6-intent-\"]){background-image:none;}"], _core.Classes.BUTTON);

/**
 * A button which shows a color picker in a popover when clicked.
 */
var ColorPicker = exports.ColorPicker = /*#__PURE__*/function (_Component) {
  function ColorPicker() {
    var _this;
    _this = _Component.call(this) || this;
    _this.handleChange = function (color) {
      var onChange = _this.props.onChange;
      onChange(color.hex);
      _this.setState({
        isOpen: false
      });
    };
    _this.handleContextMenu = function (e) {
      e.preventDefault();
      var onChange = _this.props.onChange;
      onChange(undefined);
    };
    _this.handleInteraction = function (state) {
      _this.setState({
        isOpen: state
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(ColorPicker, _Component);
  var _proto = ColorPicker.prototype;
  _proto.render = function render() {
    var _this2 = this;
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      value = _this$props.value,
      onChange = _this$props.onChange,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
      minimal: true,
      position: _core.Position.BOTTOM_LEFT,
      isOpen: this.state.isOpen,
      onInteraction: function onInteraction(state) {
        return _this2.handleInteraction(state);
      },
      content: /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeContext.Consumer, null, function (theme) {
        return /*#__PURE__*/_react["default"].createElement(_reactColor.SwatchesPicker, {
          color: value,
          onChange: _this2.handleChange,
          colors: swatchesFor(theme)
        });
      })
    }, /*#__PURE__*/_react["default"].createElement(ColorButton, _extends({}, extra, {
      onContextMenu: this.handleContextMenu,
      icon: /*#__PURE__*/_react["default"].createElement(ColorIndicator, {
        style: {
          backgroundColor: value
        }
      }),
      onClick: function onClick() {
        return _this2.setState({
          isOpen: true
        });
      }
    }), children));
  };
  return ColorPicker;
}(_react.Component);